module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-appmanage"
  }, [_c('el-row', {
    staticClass: "content-title"
  }, [_c('h2', {
    staticClass: "txt-gray"
  }, [_vm._v(_vm._s(_vm.$t('pages.apps.name')) + " : " + _vm._s(_vm.basicInfo.name))])]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.basic'),
      "name": "basic"
    }
  }, [_c('el-form', {
    ref: "basicForm",
    attrs: {
      "model": _vm.basicInfo,
      "rules": _vm.basicFromRule,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.basicInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "name", $$v)
      },
      expression: "basicInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.description'),
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.basicInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "description", $$v)
      },
      expression: "basicInfo.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.base_url'),
      "prop": "base_url"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.basicInfo.base_url),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "base_url", $$v)
      },
      expression: "basicInfo.base_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.status'),
      "prop": "is_active"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.active')
    },
    model: {
      value: (_vm.basicInfo.is_active),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "is_active", $$v)
      },
      expression: "basicInfo.is_active"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pages.apps.allow_create_user'),
      "prop": "allow_create_user"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.allow')
    },
    model: {
      value: (_vm.basicInfo.allow_create_user),
      callback: function($$v) {
        _vm.$set(_vm.basicInfo, "allow_create_user", $$v)
      },
      expression: "basicInfo.allow_create_user"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateApp
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.registration_settings'),
      "name": "configure"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.authSetting,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "allow_register",
      "label": _vm.$t('pages.appSetting.allow_register')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.allow_register),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "allow_register", $$v)
      },
      expression: "authSetting.allow_register"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verify_email",
      "label": _vm.$t('pages.appSetting.need_verify_email')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.verify_email),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "verify_email", $$v)
      },
      expression: "authSetting.verify_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verify_email_callback",
      "label": _vm.$t('pages.appSetting.verify_email_callback')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.verify_email_callback),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "verify_email_callback", $$v)
      },
      expression: "authSetting.verify_email_callback"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_pattern",
      "label": _vm.$t('pages.appSetting.password_pattern')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_pattern),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_pattern", $$v)
      },
      expression: "authSetting.password_pattern"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_description",
      "label": _vm.$t('pages.appSetting.password_description')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_description),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_description", $$v)
      },
      expression: "authSetting.password_description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "reset_password_callback",
      "label": _vm.$t('pages.appSetting.reset_password_callback')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.reset_password_callback),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "reset_password_callback", $$v)
      },
      expression: "authSetting.reset_password_callback"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAuth
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.login_settings'),
      "name": "login"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.authSetting,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "allow_weixin_login",
      "label": _vm.$t('pages.appSetting.allow_weixin_login')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.allow_weixin_login),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "allow_weixin_login", $$v)
      },
      expression: "authSetting.allow_weixin_login"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "force_weixin_login",
      "label": _vm.$t('pages.appSetting.force_weixin_login')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.force_weixin_login),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "force_weixin_login", $$v)
      },
      expression: "authSetting.force_weixin_login"
    }
  })], 1), _vm._v(" "), (_vm.authSetting.force_weixin_login) ? _c('el-form-item', {
    attrs: {
      "prop": "ignore_weixin_login",
      "label": _vm.$t('pages.appSetting.ignore_weixin_login')
    }
  }, [_vm._l((_vm.authSetting.ignore_weixin_login || []), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "closable": true,
        "close-transition": false,
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag) + "\n          ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticStyle: {
      "width": "160px",
      "vertical-align": "bottom"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ New Role")])], 2) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "login_by_email",
      "label": _vm.$t('pages.appSetting.login_by_email')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.login_by_email),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "login_by_email", $$v)
      },
      expression: "authSetting.login_by_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "login_lock",
      "label": _vm.$t('pages.appSetting.login_lock')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.login_lock),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "login_lock", $$v)
      },
      expression: "authSetting.login_lock"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "login_max_attempts",
      "label": _vm.$t('pages.appSetting.login_max_attempts')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.login_max_attempts),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "login_max_attempts", $$v)
      },
      expression: "authSetting.login_max_attempts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "access_token_expiration",
      "label": _vm.$t('pages.appSetting.access_token_expiration')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.access_token_expiration),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "access_token_expiration", $$v)
      },
      expression: "authSetting.access_token_expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "refresh_token_expiration",
      "label": _vm.$t('pages.appSetting.refresh_token_expiration')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.refresh_token_expiration),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "refresh_token_expiration", $$v)
      },
      expression: "authSetting.refresh_token_expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "need_login_sms",
      "label": _vm.$t('pages.appSetting.need_login_sms')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.need_login_sms),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "need_login_sms", $$v)
      },
      expression: "authSetting.need_login_sms"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_limit_reuse",
      "label": _vm.$t('pages.appSetting.password_limit_reuse')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_limit_reuse),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_limit_reuse", $$v)
      },
      expression: "authSetting.password_limit_reuse"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password_expiration",
      "label": _vm.$t('pages.appSetting.password_expiration')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.authSetting.password_expiration),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "password_expiration", $$v)
      },
      expression: "authSetting.password_expiration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "revoke_on_logout",
      "label": _vm.$t('pages.appSetting.revoke_on_logout')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.revoke_on_logout),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "revoke_on_logout", $$v)
      },
      expression: "authSetting.revoke_on_logout"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "revoke_on_change_pwd",
      "label": _vm.$t('pages.appSetting.revoke_on_change_pwd')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.authSetting.revoke_on_change_pwd),
      callback: function($$v) {
        _vm.$set(_vm.authSetting, "revoke_on_change_pwd", $$v)
      },
      expression: "authSetting.revoke_on_change_pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateAuth
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "email-template",
    attrs: {
      "label": _vm.$t('pages.apps.email_template'),
      "name": "email"
    }
  }, [_vm._l((_vm.emailTemplates), function(template, index) {
    return [_c('el-row', {
      key: index
    }, [_c('h4', {
      staticClass: "txt-gray"
    }, [_vm._v(_vm._s(_vm.$t(("pages.appSetting." + (template.name)))))])]), _vm._v(" "), _c('el-form', {
      key: index,
      attrs: {
        "model": template,
        "label-width": "140px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$t('pages.appSetting.type')
      }
    }, [_vm._v("\n            " + _vm._s(template.subject) + "\n          ")]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pages.appSetting.content')
      }
    }, [_c('code', [_vm._v(_vm._s(template.body))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": _vm.$t('pages.appSetting.preview')
      }
    }, [_c('div', {
      staticClass: "view-block",
      domProps: {
        "innerHTML": _vm._s(_vm.formatEmail(template.body))
      }
    })]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editEmailTemplate(template)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.edit')))])], 1)], 1)]
  })], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('pages.apps.email_server'),
      "name": "server"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.smtpSetting,
      "rules": _vm.smptRules,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "host",
      "label": _vm.$t('pages.appSetting.host')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.host),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "host", $$v)
      },
      expression: "smtpSetting.host"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "port",
      "label": _vm.$t('pages.appSetting.port')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.port),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "port", $$v)
      },
      expression: "smtpSetting.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "label": _vm.$t('common.username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.username),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "username", $$v)
      },
      expression: "smtpSetting.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": _vm.$t('common.password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.smtpSetting.password),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "password", $$v)
      },
      expression: "smtpSetting.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "use_ssl",
      "label": _vm.$t('pages.appSetting.use_ssl')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.smtpSetting.use_ssl),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "use_ssl", $$v)
      },
      expression: "smtpSetting.use_ssl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "use_tls",
      "label": _vm.$t('pages.appSetting.use_tls')
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('common.yes')
    },
    model: {
      value: (_vm.smtpSetting.use_tls),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "use_tls", $$v)
      },
      expression: "smtpSetting.use_tls"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fromname",
      "label": _vm.$t('pages.appSetting.fromname')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.smtpSetting.fromname),
      callback: function($$v) {
        _vm.$set(_vm.smtpSetting, "fromname", $$v)
      },
      expression: "smtpSetting.fromname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateSmtp
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('pages.appSetting.verify_email')
    },
    model: {
      value: (_vm.editEmail),
      callback: function($$v) {
        _vm.editEmail = $$v
      },
      expression: "editEmail"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.emailTemplate,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "subject",
      "label": _vm.$t('pages.appSetting.type')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.emailTemplate.subject),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate, "subject", $$v)
      },
      expression: "emailTemplate.subject"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "body",
      "label": _vm.$t('pages.appSetting.content')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": _vm.rows
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateEmailTemplate($event)
      }
    },
    model: {
      value: (_vm.emailTemplate.body),
      callback: function($$v) {
        _vm.$set(_vm.emailTemplate, "body", $$v)
      },
      expression: "emailTemplate.body"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips-danger"
  }, [_vm._v(_vm._s(_vm.$t('pages.appSetting.email_notify')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateEmailTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('common.save')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63415a10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppManage.vue
// module id = 386
// module chunks = 1